import Vue from 'vue'

import firebase from 'firebase/app'
import VueFire from 'vuefire'
import VueAnalytics from 'vue-analytics'
import VeeValidate from 'vee-validate'
import lodash from 'lodash'
import moment from 'moment'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import * as VueGoogleMaps from "vue2-google-maps"

import patientRepository from './data/PatientRepository'

import PhoneNumber from 'awesome-phonenumber'

VeeValidate.Validator.extend('phone', {
    getMessage: field => 'The ' + field + ' value is not a valid phone number.',
    validate: (value, [country]) => {
        let phoneNumber = new PhoneNumber(value, country)
        return phoneNumber.isValid()
    }
})

import Buefy from 'buefy'
import ToggleButton from 'vue-js-toggle-button'
import Avatar from '@/components/Avatar.vue'
import DfpSlot from '@/components/DfpSlot.vue'
import PatientLoadingBlock from '@/components/Patient/LoadingBlock.vue'

import App from '@/App'

import router from '@/router'
import i18n from '@/i18n'
import { store } from '@/store'
import {db} from '@/firebase'

import countryRepository from '@/data/CountryRepository'
import languageRepository from '@/data/LanguageRepository'

Vue.config.productionTip = false
Vue.config.devtools = true

let app;

window.bugsnagClient = bugsnag(process.env.BUGSNAG_KEY);
window.bugsnagClient.use(bugsnagVue, Vue);

const isProd = process.env.FIREBASE_ENV === 'prod'

Vue.use(VueFire);
Vue.use(VueAnalytics, {
    id: process.env.ANALYTICS_ID,
    router,
    autoTracking: {
        page: true,
        screenview: false,
        transformQueryString: false,
        pageViewOnLoad: false
    },
    debug: {
        enabled: false, //!isProd,
        sentHitTask: isProd
    },
    checkDuplicatedScript: true
});
Vue.use(Buefy);
Vue.use(VeeValidate);
Vue.use(ToggleButton);
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MAPS_API_KEY,
        libraries: "places"
    }
})

Vue.component('avatar', Avatar);
Vue.component('dfp-slot', DfpSlot);
Vue.component('patient-loading', PatientLoadingBlock);

Vue.set(Vue.prototype, '_', lodash)

Vue.filter('momentFormatTimestamp', (timestamp, toFormat) => {
    return moment(timestamp).format(toFormat)
})

Vue.filter('momentFormat', (date, fromFormat, toFormat) => {
    return moment(date, fromFormat).format(toFormat)
})

Vue.filter('momentFormatTime', (time, toFormat) => {
    let start = moment.duration(time * 15, 'minutes')

    return moment.utc(start.asMilliseconds()).format(toFormat)
})

firebase.auth().onAuthStateChanged((user) => {
    let promises = []
    promises.push(setupUser(user))
    promises.push(setupPatient(user))
    promises.push(setupDoctor(user))
    promises.push(setupRecommendations(user))
    if (Object.keys(store.state.countries).length == 0) {
        promises.push(setupCountries())
    }
    if (Object.keys(store.state.languages).length == 0) {
        promises.push(setupLanguages())
    }

    Promise.all(promises)
        .then(() => {
            if (document.getElementById('app')) {
                window.bugsnagClient.user = {
                    userId: store.state.userId,
                    doctor: store.state.doctor
                }

                new Vue({
                    el: '#app',
                    router,
                    i18n,
                    store,
                    render: h => h(App)
                })
            }
        })
        .catch(error => {
            console.log('some promises could not resolve', error)
        })
})

// setup the user
const setupUser = (user) => {
    return new Promise( (resolve, reject) => {
        store.dispatch('setUserId', user ? user.uid : null)

        resolve()
    })
}

// Check if user is a patient
const setupPatient = (user) => {
    return new Promise( (resolve, reject) => {
        store.dispatch('setPatient', null)

        if (! user) {
            resolve()

            return
        }

        patientRepository.createOrUpdate(user, (patient) => {
            store.dispatch('setPatient', patient)

            resolve()
        }, reject)
    })
}

// Check if user is a doctor
const setupDoctor = (user) => {
    return new Promise( (resolve, reject) => {
        store.dispatch('setDoctor', null)

        if (! user) {
            resolve()

            return
        }

        db.collection('doctors')
            .doc(user.uid)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    store.dispatch('setDoctor', doc.data())
                }

                resolve()
            })
            .catch(reject)
    })
}

// Fetch the doctor recommendations
const setupRecommendations = (user) => {
    return new Promise( (resolve, reject) => {
        if (! user) {
            resolve()

            return
        }

        db.collection('recommendations')
            .where('fromId', '==', user.uid)
            .get()
            .then((querySnapshot) => {
                let recommendations = {}

                querySnapshot.forEach((doc) => {
                    recommendations[doc.id] = doc.data()
                });

                store.dispatch('setRecommendations', recommendations)

                resolve()
            })
            .catch(reject)
    })
}

// fetch countries
const setupCountries = () => {
    return new Promise( (resolve, reject) => {
        countryRepository.list((countries) => {
            store.dispatch('setCountries', countries)
            resolve()
        }, reject)
    })
}

// fetch languages
const setupLanguages = () => {
    return new Promise( (resolve, reject) => {
        languageRepository.list((languages) => {
            store.dispatch('setLanguages', languages)
            resolve()
        }, reject)
    })
}

// calculate distance between 2 coordinates
window.distanceBetween = (lat1, lon1, lat2, lon2, unit) => {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515

    return dist * 1.609344; // Degrees to km, rounded to the km
}



// WEBPACK FOOTER //
// ./src/main.js